<template>
  <main class="flex-shrink-0 container shadow">
    <div class="container">
      <personnummer v-if="activePage === 'personnummer'"/>
      <kontonummer-validator v-if="activePage === 'kontonummer'"/>
      <person v-if="activePage === 'person'"/>
    </div>

  </main>
</template>

<script>

export default {
  name: 'testdata-main',
  props: ['activePage']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

body {
  padding-top: 65px;
}

.rainbow-text {
  background-image: linear-gradient(to left, violet, indigo, blue, green, yellow, orange, red);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}


</style>

